define('config/routeIds',{
    NOT_FOUND: '404',
    HOME: 'home',
    AFFILIATE: 'affiliate',
    ABOUT: 'about-us',
    FAQ: 'faq',
    GAMES: 'games',
    GAMES_TOP: 'games-top',
    GAMES_ALL: 'games-all',
    GAMES_SEARCH: 'games-search',
    REEL_RACES: 'reel-races',
    DEPOSIT: 'deposit',
    DEPOSIT_SUCCESS: 'deposit-success',
    DEPOSIT_FAILURE: 'deposit-failure',
    WITHDRAW: 'withdraw',
    WITHDRAW_SUCCESS: 'withdraw-success',
    WITHDRAW_FAILURE: 'withdraw-failure',
    HISTORY: 'history',
    HISTORY_BETS: 'history-bets',
    PLAYER: 'player',
    PLAYER_VALUABLES: 'player-valuables',
    SIGN_UP: 'sign-up',
    PLAY: 'play',
    PRACTICE: 'practice',
    LOG_IN: 'log-in',
    CHANGE_PASSWORD: 'change-password',
    UNSUBSCRIBE: 'unsubscribe',
    IDDQD: 'iddqd',
    IDDQD_LIGHT: 'iddqd-light',
    PLAY_OKAY: 'play-okay',
    SETTINGS: 'settings',
    PHONE_NUMBER_CHANGE: 'phone-number-change',
    RETURN_FROM_GAME_NETENT: 'return-from-game-netent',
    OVERLAY_GAME_LAUNCHER: 'overlay-game-launcher',
    OVERLAY_GAME_2: 'overlay-game-2',
    ITUNES_TERMS: 'itunes-terms'
});

